import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';

const isTest = import.meta.env.MODE === 'test';
const isProduction = import.meta.env.MODE === 'production';

const resolveEnv = (key: string, fallback?: string): string => {
  const value = import.meta.env[key];
  if (value && value.trim().length > 0) {
    return value;
  }

  if (isProduction) {
    throw new Error(`Missing required environment variable: ${key}`);
  }

  if (fallback) {
    if (!isTest) {
      console.warn(`Using fallback Firebase config value for ${key}. Set ${key} in your environment.`);
    }
    return fallback;
  }

  return '';
};

// Firebase configuration
// Note: These are public configuration values, not secrets
export const firebaseConfig = {
  apiKey: resolveEnv('VITE_FIREBASE_API_KEY', 'demo-api-key'),
  authDomain: resolveEnv('VITE_FIREBASE_AUTH_DOMAIN', 'buildgravity-platform.firebaseapp.com'),
  projectId: resolveEnv('VITE_FIREBASE_PROJECT_ID', 'buildgravity-platform'),
  storageBucket: resolveEnv('VITE_FIREBASE_STORAGE_BUCKET', 'buildgravity-platform.appspot.com'),
  messagingSenderId: resolveEnv('VITE_FIREBASE_MESSAGING_SENDER_ID', '000000000000'),
  appId: resolveEnv('VITE_FIREBASE_APP_ID', '1:000000000000:web:demoapp'),
  measurementId: resolveEnv('VITE_FIREBASE_MEASUREMENT_ID', undefined) // Google Analytics
};

if (isProduction) {
  const missing = Object.entries(firebaseConfig)
    .filter(([, value]) => !value)
    .map(([key]) => key);
  if (missing.length > 0) {
    throw new Error(`Missing Firebase configuration values: ${missing.join(', ')}`);
  }
}

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);

export default app;